// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { GlobalEvent, GlobalState } from './GlobalContext';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import MsgDialog from './MsgDialog';
import DocCmtAddDialog from './DocCmtAddDialog';
import DocCmtDetailDialog from './DocCmtDetailDialog';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import PreviewIcon from '@mui/icons-material/Preview';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from "dayjs"

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export default function DocCmtTab(props) {
  const { sysID, docDetail, afterUpdate } = props;

  const sources = docDetail.Comments || [];

  const gridData = sources.map(item => {
    return {
      ...item,
      CreateDateJs: dayjs(item.CreateDate),
      CreateDateDisplay: dayjs(item.CreateDate).format(DmsCommon.SHORT_DATE_FORMAT),
    }
  })

  // console.log("gridData", gridData);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  // const [selectedRecs, setSelectedRecs] = useState([]);
  const [selectedCmt, setSelectedCmt] = useState(null);
  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();

    let selRecs = nodes.map(item => {
      return item.data
    });

    // setSelectedRecs(selRecs);
    if (selRecs.length > 0) {
      setSelectedCmt(selRecs[0])
    } else {
      setSelectedCmt(null)
    }

  }

  const [openAddCmtDialog, setOpenAddCmtDialog] = useState(false);
  const [openCmtDetailDialog, setOpenCmtDetailDialog] = useState(false);


  const handleClickAdd = () => {
    if (docDetail.Permission < DmsCommon.AccessRightEnum.arModify) {
      setErrMsg("Can't add comment. Access denied!");
      setShowError(true);
      return
    }

    setEditMode(false);
    setOpenAddCmtDialog(true);
  }

  const handleClickEdit = () => {
    if (docDetail.Permission < DmsCommon.AccessRightEnum.arModify) {
      setErrMsg("Can't edit comment. Access denied!");
      setShowError(true);
      return
    }

    setEditMode(true);
    setOpenAddCmtDialog(true);

  }



  const handleAfterUpdate = () => {
    setOpenAddCmtDialog(false);
    setSelectedCmt(null);

    afterUpdate && afterUpdate();
  }

  const [editMode, setEditMode] = useState(false);

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };


  const comparatorCreateDate = (a, b, nodeA, nodeB) => {

    const [aDate, bDate] = [nodeA.data.CreateDateJs, nodeB.data.CreateDateJs];
    if (aDate.isBefore(bDate)) {
      return -1;
    } else if (aDate.isAfter(bDate)) {
      return 1;
    } else {
      return 0;
    }
  }


  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorCreatedBy = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.CreatedBy, nodeB.data.CreatedBy)
  }

  const comparatorText = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Text, nodeB.data.Text)
  }

  const columnDefs = [
    { field: 'CreateDateDisplay', headerName: "Date", cellStyle: cellStyle, comparator: comparatorCreateDate },
    { field: 'CreatedBy', headerName: "User", cellStyle: cellStyle, width: 150, comparator: comparatorCreatedBy },
    {
      field: 'Text', headerName: "Comment", cellStyle: cellStyle, minWidth: 150, flex: "1",
      autoHeight: true, wrapText: true, comparator: comparatorText
    },
  ];



  return (
    <Box sx={{ display: 'flex', height: "70vh" }} >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
        <Box sx={{ py: 1, px: 1 }} >
          <DocCmtAddDialog
            sysID={sysID}
            open={openAddCmtDialog}
            editMode={editMode}
            editCmt={selectedCmt}
            onClose={() => setOpenAddCmtDialog(false)}
            docDetail={docDetail}
            afterUpdate={handleAfterUpdate}
          />
          <DocCmtDetailDialog
            open={openCmtDetailDialog}
            onClose={() => setOpenCmtDetailDialog(false)}
            docDetail={docDetail}
          />

          <Button startIcon={<AddIcon />} onClick={handleClickAdd}   >
            Add
          </Button>

          <Button startIcon={<EditIcon />} onClick={handleClickEdit} disabled={!selectedCmt}  >
            Edit
          </Button>

          <Button startIcon={<PreviewIcon />} onClick={() => setOpenCmtDetailDialog(true)} disabled={gridData.length == 0} >
            Details
          </Button>

        </Box>

        <AgGridReact

          rowData={gridData}

          defaultColDef={{
            width: 100,
            resizable: true,
            sortable: true,
            suppressMovable: true,
          }}
          columnDefs={columnDefs}
          headerHeight={40}

          suppressNoRowsOverlay

          rowSelection="single"
          onSelectionChanged={onSelectionChanged}
        >


        </AgGridReact>

      </div>

    </Box>


  );
}

DocCmtTab.propTypes = {
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  afterUpdate: PropTypes.func,
};
